import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import IconButton, {IconButtonProps} from '@material-ui/core/IconButton';
import theme from '../../theme';
import {GRANITE_7, GRANITE_6, GRANITE_3} from '../../colors';
import {makeStyles} from '@material-ui/styles';
import {closeButtonZIndex} from '../../utils/gaia/zIndicies';

const useStyles = makeStyles({
    closeButton: {
        backgroundColor: GRANITE_7,
        '&:hover': {backgroundColor: GRANITE_6}
    }
});

export type CloseButtonProps = IconButtonProps;

export default function CloseButton({style, ...props}: CloseButtonProps) {
    const classes = useStyles();

    return <IconButton
        style={{
            padding: theme.spacing(0.5),
            zIndex: closeButtonZIndex,
            boxShadow: theme.shadows[3],
            ...style,
        }}
        className={classes.closeButton}
        {...props}
    >
        <CloseIcon style={{color: GRANITE_3}} />
    </IconButton>;
}
